import { exportExcel } from "@api/stores/productReports/exportExcel/path";
import { exportPDF } from "@api/stores/productReports/exportPDF/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/product-reports/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const productReports = {
  getAll: apiPathFunc(pathBase),
  exportPDF,
  exportExcel,
};
